import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { types, initialState } from './types'

export const saveBuildABillForm = (expenseUuid, buildABillData) => ({
  [RSAA]: {
    endpoint: getApiPath('exp', `expenses/${expenseUuid}/expense-form`),
    method: 'PUT',
    body: JSON.stringify({
      formType: 'BUILD_A_BILL',
      ...buildABillData,
    }),
    types: [
      types.SAVE_BUILD_A_BILL_FORM_REQUEST,
      {
        type: types.SAVE_BUILD_A_BILL_FORM_SUCCESS,
        meta: { expenseUuid },
      },
      types.SAVE_BUILD_A_BILL_FORM_ERROR,
    ],
  },
})

export const fetchBuildABillForm = expenseUuid => ({
  [RSAA]: {
    endpoint: getApiPath(
      'exp',
      `expenses/${expenseUuid}/expense-form?formType=BUILD_A_BILL`,
    ),
    method: 'GET',
    types: [
      types.FETCH_BUILD_A_BILL_FORM_REQUEST,
      types.FETCH_BUILD_A_BILL_FORM_SUCCESS,
      types.FETCH_BUILD_A_BILL_FORM_ERROR,
    ],
  },
})

export const clearBuildABillError = () => ({
  type: types.CLEAR_BUILD_A_BILL_ERROR,
})

export const clearBuildABillData = () => ({
  type: types.CLEAR_BUILD_A_BILL_DATA,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.SAVE_BUILD_A_BILL_FORM_REQUEST:
    case types.FETCH_BUILD_A_BILL_FORM_REQUEST: {
      return {
        ...state,
        buildABill: {
          ...state.buildABill,
          busy: true,
          error: null,
        },
      }
    }

    case types.SAVE_BUILD_A_BILL_FORM_SUCCESS:
    case types.FETCH_BUILD_A_BILL_FORM_SUCCESS: {
      return {
        ...state,
        buildABill: {
          ...state.buildABill,
          busy: false,
          entity: payload,
          error: null,
        },
      }
    }

    case types.SAVE_BUILD_A_BILL_FORM_ERROR:
    case types.FETCH_BUILD_A_BILL_FORM_ERROR: {
      return {
        ...state,
        buildABill: {
          ...state.buildABill,
          busy: false,
          error: payload.message || 'An error occurred',
        },
      }
    }

    case types.CLEAR_BUILD_A_BILL_ERROR: {
      return {
        ...state,
        buildABill: {
          ...state.buildABill,
          error: null,
        },
      }
    }

    case types.CLEAR_BUILD_A_BILL_DATA: {
      return {
        ...state,
        buildABill: {
          busy: false,
          entity: {},
          error: null,
        },
      }
    }

    default:
      return state
  }
}
